import React, { Fragment, useEffect, useState } from 'react'
import { Row, Col, Container, Table } from 'reactstrap'
import { Drawer } from '@material-ui/core'
import { TextFieldHookForm, SearchableSelectHookForm } from '../../../../src/components/layout/HookFormInputs'
import { useForm, Controller } from 'react-hook-form'
import NoContentFound from '../../../../src/components/common/NoContentFound'
import { reactLocalStorage } from 'reactjs-localstorage'
import { number, checkWhiteSpaces, percentageLimitValidation, decimalNumberLimit6, checkForNull, checkForDecimalAndNull, hashValidation, maxLength80 } from "../../../../src/helper/validation";
import { useDispatch, useSelector } from 'react-redux'
import { COMMODITYCOST, EMPTY_DATA, RAWMATERIALCOST } from '../../../../src/config/constants'
import Toaster from '../../../../src/components/common/Toaster';
import { getCostingCondition } from '../../../actions/Common'
import { generateCombinations, getCostingConditionTypes } from '../../common/CommonFunctions'

function AddOtherCostDrawer(props) {
    const initialConfiguration = useSelector((state) => state.auth.initialConfiguration)
    const dispatch = useDispatch();



    const { rmBasicRate, isFromImport, RowData, RowIndex, isImport, plantCurrency, settlementCurrency, isBOP, RawMaterialNonIndexed = true, bopBasicRate } = props
    const Currency = RawMaterialNonIndexed ? settlementCurrency : ((isBOP && isImport) ? settlementCurrency : isBOP && !isImport ? plantCurrency : props?.RowData?.IndexCurrency) || 'Currency'
    const CurrencyLabel = RawMaterialNonIndexed ? settlementCurrency : (!props.rawMaterial ? reactLocalStorage.getObject('baseCurrency') : isImport && (props.rawMaterial || isBOP) ? settlementCurrency : plantCurrency) || 'Currency'

    const UOM = props?.RowData?.IndexUOM || (Array.isArray(props?.uom) ? '' : props?.uom?.label) || '';
    const [tableData, setTableData] = useState([]);

    const [disableTotalCost, setDisableTotalCost] = useState(true)
    const [disableAllFields, setDisableAllFields] = useState(true)
    const [editIndex, setEditIndex] = useState('')
    const [isEditMode, setIsEditMode] = useState(false)
    const [type, setType] = useState('')
    const [totalCostCurrency, setTotalCostCurrency] = useState('')
    const [totalCostBase, setTotalCostBase] = useState('')
    const [disableCurrency, setDisableCurrency] = useState(false)
    const [availableApplicabilities, setAvailableApplicabilities] = useState(["Basic Rate"]);
    const [RawMaterialCommodityIndexRateAndOtherCostDetailsId, setRawMaterialCommodityIndexRateAndOtherCostDetailsId] = useState('')
    const ExchangeRate = RowData?.ExchangeRate
    const BasicRateIndexCurrency = RowData?.BasicRate
    const [state, setState] = useState({
        Applicability: false,
        rowData: {},
        disableApplicability: true,
        premiumCost: '',
        disableCostCurrency: false,
        disableCostBaseCurrency: false,
        costDropdown: []
    })
    const [exactCostValues, setExactCostValues] = useState({
        ApplicabilityCostCurrency: '',
        ApplicabilityBaseCost: '',
        CostCurrency: '',
        CostBaseCurrency: ''
    });
    const conditionTypeId = getCostingConditionTypes(props.rawMaterial ? RAWMATERIALCOST : COMMODITYCOST)
    useEffect(() => {
        if (!tableData || tableData.length === 0) {
            setTotalCostBase(0);
            setTotalCostCurrency(0);
            return;
        }

        // Filter out "Discount Cost" entries
        const filteredTableData = tableData.filter(obj => obj.CostHeaderName !== "Discount Cost");

        // Calculate the sum for NetCostConversion excluding "Discount Cost"
        const sumNetCostConversion = filteredTableData.reduce((acc, obj) => checkForNull(acc) + checkForNull(obj.NetCostConversion), 0);

        // Calculate the sum for NetCost excluding "Discount Cost"
        const sumNetCost = tableData.reduce((acc, obj) => checkForNull(acc) + checkForNull(obj.NetCost), 0);

        // Find the first "Discount Cost" entry, if any
        const discountCostEntry = tableData.find(obj => obj.CostHeaderName === "Discount Cost");
        const discountNetCostConversion = discountCostEntry ? checkForNull(discountCostEntry.NetCostConversion) : 0;

        // Calculate the final totalCostBase by applying the discount
        const totalCostBase = sumNetCostConversion - Math.abs(discountNetCostConversion);

        // Check if the tableData contains only "Discount Cost" entries
        const isOnlyDiscountCost = tableData.every(obj => obj.CostHeaderName === "Discount Cost");

        // Update state
        setTotalCostBase(isOnlyDiscountCost ? discountNetCostConversion : totalCostBase);
        setTotalCostCurrency(sumNetCost);

    }, [tableData]);
    useEffect(() => {
        if (props.rawMaterial === true || isBOP) {
            setTableData(props.rmTableData)
        } else {

            if (Array.isArray(props.RowData?.RawMaterialCommodityIndexRateDetailsRequest)) {
                const filteredData = props?.tableData?.filter(item =>
                    props.RowData.RawMaterialCommodityIndexRateDetailsRequest.some(req =>
                        req.RawMaterialCommodityIndexRateAndOtherCostDetailsId === item.RawMaterialCommodityIndexRateAndOtherCostDetailsId
                    )
                );
                setTableData(filteredData);
            } else {
                setTableData([]);
            }
        }
    }, [props.RowData, props.tableData]);
    useEffect(() => {
        dispatch(getCostingCondition('', conditionTypeId, (res) => {
            if (res?.data?.DataList) {
                const temp = res?.data?.DataList?.map((item) => ({
                    label: item?.CostingConditionNumber,
                    value: item?.CostingConditionMasterId,
                }));
                setState((prevState) => ({
                    ...prevState,
                    costDropdown: temp
                }));
            }
        }));
    }, [])
    useEffect(() => {
        updateAvailableApplicabilities();
    }, [tableData, state.costDropdown]);
    const updateAvailableApplicabilities = () => {
        const newApplicabilities = ["Basic Rate"];
        tableData?.forEach(item => {
            if (item.CostHeaderName !== "Basic Rate" && !newApplicabilities.includes(item.CostHeaderName)) {
                newApplicabilities.push(item.CostHeaderName);
            }
        });
        setAvailableApplicabilities(newApplicabilities);
    };
    const editData = (indexValue, operation) => {
        if (operation === 'delete') {
            handleDelete(indexValue);
        } else if (operation === 'edit') {
            handleEdit(indexValue);
        }

    }
    const handleEdit = (indexValue) => {
        setEditIndex(indexValue);
        setIsEditMode(true);

        let selectedData = tableData[indexValue];

        // Store raw values in exactCostValues state
        setExactCostValues({
            ApplicabilityCostCurrency: selectedData.ApplicabilityCost,
            ApplicabilityBaseCost: selectedData.ApplicabilityCostConversion,
            CostCurrency: selectedData.NetCost,
            CostBaseCurrency: isBOP || RawMaterialNonIndexed ? selectedData?.NetCost : selectedData.NetCostConversion
        });

        setValue('Cost', {
            label: selectedData.CostHeaderName,
            value: selectedData.CostingConditionMasterId
        });
        setValue('Type', {
            label: selectedData.Type,
            value: selectedData.Type
        });
        setType({
            label: selectedData.Type,
            value: selectedData.Type
        });
        setValue('Percentage', selectedData.Value);
        setValue('Applicability', {
            label: selectedData.Applicability,
            value: selectedData.Applicability
        });
        setValue('ApplicabilityCostCurrency', checkForDecimalAndNull(selectedData.ApplicabilityCost, initialConfiguration?.NoOfDecimalForPrice));
        setValue('ApplicabilityBaseCost', isBOP ? checkForDecimalAndNull(selectedData.ApplicabilityCost, initialConfiguration?.NoOfDecimalForPrice) : checkForDecimalAndNull(selectedData.ApplicabilityCostConversion, initialConfiguration?.NoOfDecimalForPrice));
        setValue('CostCurrency', checkForDecimalAndNull(selectedData.NetCost, initialConfiguration?.NoOfDecimalForPrice));
        setValue('CostBaseCurrency', isBOP || RawMaterialNonIndexed ? checkForDecimalAndNull(selectedData?.NetCost, initialConfiguration?.NoOfDecimalForPrice) : checkForDecimalAndNull(selectedData.NetCostConversion, initialConfiguration?.NoOfDecimalForPrice));
        setValue('CostDescription', selectedData.Description);
        setValue('Remark', selectedData.Remark);
        setRawMaterialCommodityIndexRateAndOtherCostDetailsId(selectedData?.RawMaterialCommodityIndexRateAndOtherCostDetailsId ?? null)
        // setTotalCostCurrency(selectedData.CostCurrency);
        // setType(selectedData.ConditionType);

        // Update UI state based on the type
        // if (selectedData.Type === 'Fixed') {
        //     setDisableTotalCost(false);
        //     setDisableCurrency(false);

        //     setDisableAllFields(true);
        // } else {
        //     setState(prevState => ({ ...prevState, disableApplicability: false }));
        // }
    };

    const handleDelete = (indexValue) => {
        let updatedData = tableData.filter((_, index) => index !== indexValue);
        setTableData(updatedData);
        resetData();
    };

    const editDeleteData = (indexValue, operation) => {

        editData(indexValue, operation)
    }

    const { register, control, setValue, getValues, handleSubmit, reset, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })
    const toggleCondition = () => {
        let cssClass = '';
        if (isFromImport) {
            if (type === "") {
                cssClass = 'mb-3';
            } else if (type === "Fixed") {
                cssClass = 'mb-3';
            } else {
                cssClass = 'mt-4 pt-1';
            }
        } else {
            if (type === "") {
                cssClass = 'mt-4 pt-1';
            } else if (type === "Fixed") {
                cssClass = 'mb-3';
            } else {
                cssClass = 'mt-4 pt-1 mb-5 pb-3';
            }
            if (props.isFromMaster) {
                if (type === "Percentage") {
                    cssClass = 'mb-3';
                } else {
                    cssClass = 'mt-4 pt-1 mb-5 pb-1';
                }
            }
        }
        return cssClass
    }
    const applicabilityChange = (e) => {

        // Handle Basic Rate separately
        if (e?.label === 'Basic Rate') {
            let basicRate = props.rawMaterial ? rmBasicRate : BasicRateIndexCurrency * ExchangeRate
            setExactCostValues({
                ApplicabilityCostCurrency: BasicRateIndexCurrency,
                ApplicabilityBaseCost: basicRate
            });
            setValue('ApplicabilityCostCurrency', checkForDecimalAndNull(BasicRateIndexCurrency, initialConfiguration?.NoOfDecimalForPrice));
            setValue('ApplicabilityBaseCost', checkForDecimalAndNull(basicRate, initialConfiguration?.NoOfDecimalForPrice));
            setState(prevState => ({ ...prevState, Applicability: e?.label }));
            return; // Exit early for Basic Rate
        }

        // For other applicabilities
        // Check which applicabilities are selected
        const selectedApplicabilities = e?.label?.split(' + ');

        // Calculate total cost currency for selected applicabilities
        let totalCostCurrency = 0;
        let allExist = true;
        let missingCosts = []; // Array to hold missing costs
        let totalBasicRate
        let total

        selectedApplicabilities.forEach(Applicability => {
            // Skip checking for "Basic Rate" in tableData
            if (Applicability === 'Basic Rate') {
                return;
            }
            const item = tableData.find(item => item?.CostHeaderName === Applicability);
            if (item) {
                totalCostCurrency += props.isBOP ? Number(item?.NetCost) : Number(item?.NetCostConversion);
                if (selectedApplicabilities.includes('Basic Rate')) {
                    // totalCostCurrency += BasicRateIndexCurrency;
                    totalBasicRate = props.rawMaterial ? rmBasicRate : BasicRateIndexCurrency
                    total = checkForNull(totalCostCurrency) + checkForNull(totalBasicRate)
                } else {
                    total = checkForNull(totalCostCurrency)
                }
            } else {
                // Add missing Applicability to the array
                missingCosts.push(Applicability);
                // Set flag to indicate not all applicabilities exist
                allExist = false;
            }
        });

        // If not all applicabilities exist, handle the condition
        if (!allExist) {
            // Show toaster message with all missing costs
            Toaster.warning(`Cost(s) for ${missingCosts.join(', ')} do not exist in the table, please add data first before proceeding further`);
            // You may choose to reset values or handle differently
            setValue('ApplicabilityCostCurrency', 0);
            setValue('ApplicabilityBaseCost', 0);
            setExactCostValues({
                ApplicabilityCostCurrency: 0,
                ApplicabilityBaseCost: 0
            });
        } else {
            // Set ApplicabilityCostCurrency and ApplicabilityBaseCost if all exis
            setExactCostValues({
                ApplicabilityCostCurrency: total,
                ApplicabilityBaseCost: props.rawMaterial ? total : total * ExchangeRate
            });
            setValue('ApplicabilityCostCurrency', checkForDecimalAndNull(total, initialConfiguration?.NoOfDecimalForPrice));
            const totalBaseCost = props.rawMaterial ? total : total * ExchangeRate;
            // console.log("here1",totalBaseCost)
            // console.log(checkForDecimalAndNull(totalBaseCost, 3),"here2")
            setValue('ApplicabilityBaseCost', checkForDecimalAndNull(totalBaseCost, initialConfiguration?.NoOfDecimalForPrice));
        }

        setState(prevState => ({ ...prevState, Applicability: e?.label }));
    }
    const onPercentChange = (e) => {
        if (e?.target?.value) {
             // Use exact values from state for calculation
            let applicabilityCostCurrency = props.rawMaterial
                ? exactCostValues.ApplicabilityBaseCost
                : exactCostValues.ApplicabilityCostCurrency;
            let NetCost = checkForNull((e.target.value) / 100) * checkForNull(applicabilityCostCurrency)
            let NetCostConversion = props.rawMaterial ? NetCost : NetCost * ExchangeRate
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: NetCost,
                CostBaseCurrency: NetCostConversion
            }));
            setValue('CostCurrency', checkForDecimalAndNull(NetCost, initialConfiguration?.NoOfDecimalForPrice))
            setValue('CostBaseCurrency', checkForDecimalAndNull(NetCostConversion, initialConfiguration?.NoOfDecimalForPrice))
        }
    }

    const cancel = () => {
        props.closeDrawer('Cancel', tableData, totalCostCurrency, totalCostBase, RowIndex)
    }


    const handleCostChangeCurrency = (e) => {
        if (e?.target?.value) {
            const exactValue = checkForNull(e.target.value);
            const exactBaseValue = exactValue * ExchangeRate;

            // Store exact values
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: exactValue,
                CostBaseCurrency: exactBaseValue
            }));

            // Set formatted values
            setValue('CostBaseCurrency', checkForDecimalAndNull(exactBaseValue, initialConfiguration?.NoOfDecimalForPrice));
            setState(prevState => ({ ...prevState, disableCostBaseCurrency: true }));
        } else {
            setValue('CostBaseCurrency', '');
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: '',
                CostBaseCurrency: ''
            }));
            setState(prevState => ({ ...prevState, disableCostBaseCurrency: false }));
        }
    }
    const handleCostChangeBase = (e) => {
        if (e?.target?.value) {
            const exactBaseValue = checkForNull(e.target.value);
            const exactValue = exactBaseValue / ExchangeRate;

            // Store exact values
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: exactValue,
                CostBaseCurrency: exactBaseValue
            }));

            // Set formatted values
            setValue('CostCurrency', checkForDecimalAndNull(exactValue, initialConfiguration?.NoOfDecimalForPrice));
            setState(prevState => ({ ...prevState, disableCostCurrency: true }));
        } else {
            setValue('CostCurrency', '');
            setExactCostValues(prev => ({
                ...prev,
                CostCurrency: '',
                CostBaseCurrency: ''
            }));
            setState(prevState => ({ ...prevState, disableCostCurrency: false }));
        }
    }

    /**
    * @method renderListing
    * @description RENDER LISTING IN DROPDOWN
    */
    const renderListing = (label) => {
        if (label === 'Type') {
            return [
                { label: "Percentage", value: "Percentage" },
                { label: "Fixed", value: 'Fixed' }
            ]
        }
        return [];
    }

    const combinations = generateCombinations(availableApplicabilities, "Basic Rate");

    const onSubmit = data => {
        addData();
    }
    const addData = () => {
        const type = getValues('Type');
        const cost = getValues('Cost');
        const applicability = getValues('Applicability');
        const percentage = Number(getValues('Percentage'));
        const costBaseCurrency = getValues('CostBaseCurrency');
        const applicabilityBaseCost = getValues('ApplicabilityBaseCost');
        const remark = getValues('Remark');
        const costDescription = getValues('CostDescription');

        // Check for form errors first
        if (Object.keys(errors).length > 0) {
            Toaster.warning('Please fix all validation errors before adding.');
            return false;
        }


        // If 'Type' is not provided, return false
        if (!type || !cost || !remark || !costDescription) { Toaster.warning('Please enter all mandatory details to add a row.'); return false };
        if (type.label === "Percentage") {
            // If 'Type' is 'percentage', check for 'Applicability' and 'Percentage'
            if (!applicability || !applicabilityBaseCost || !percentage || percentage === 0) {
                Toaster.warning('Cost should not be zero or empty.');
                return false;
            }
        } else if (type.label === 'Fixed') {
            // If 'Type' is 'fixed', check for 'CostCurrency' and 'CostBaseCurrency'
            if (!costBaseCurrency) { Toaster.warning('Please enter all details to add a row.'); return false };
        }
        // Create new data entry
        const newData = {
            MaterialCommodityStandardDetailsId: RowData?.MaterialCommodityStandardDetailsId, // Add MaterialCommodityStandardDetailsId
            RawMaterialCommodityIndexRateAndOtherCostDetailsId: RawMaterialCommodityIndexRateAndOtherCostDetailsId ?? null,
            Type: getValues('Type') ? getValues('Type').label : '-',
            CostHeaderName: getValues('Cost') ? getValues('Cost').label : '-',
            Applicability: getValues('Applicability') ? getValues('Applicability').label : '-',
            ApplicabilityCost: props.rawMaterial ? exactCostValues.ApplicabilityBaseCost : exactCostValues.ApplicabilityCostCurrency ? exactCostValues.ApplicabilityCostCurrency : '-',
            ApplicabilityCostConversion: exactCostValues.ApplicabilityBaseCost ? exactCostValues.ApplicabilityBaseCost : '-',
            Value: getValues('Percentage') ? getValues('Percentage') : '-',
            NetCost: props.rawMaterial ? exactCostValues.CostBaseCurrency : exactCostValues.CostCurrency,
            NetCostConversion: exactCostValues.CostBaseCurrency,
            Description: getValues('CostDescription') ? getValues('CostDescription') : '-',
            CostingConditionMasterId: getValues('Cost') ? getValues('Cost').value : '-',
            Remark: getValues('Remark')
        };
        // If the CostHeaderName is 'Discount Cost', prepend '-' sign
        if (newData.CostHeaderName === 'Discount Cost') {
            if (newData.NetCost === rmBasicRate) {
                Toaster.warning('Discount should not be equal to Basic rate')
                return false
            }
            newData.NetCost = `-${newData.NetCost}`;
            newData.NetCostConversion = `-${newData.NetCostConversion}`;
        }
        // Assuming 'tableData' is an array of objects and you want to add MaterialCommodityStandardDetailsId separately,
        // you can structure your updated data as follows:
        const updatedData = {
            MaterialCommodityStandardDetailsId: RowData?.MaterialCommodityStandardDetailsId,
            data: [] // This will hold your actual tableData with the new item added if necessary
        };

        // Check if CostHeaderName already exists in tableData, excluding the current item in edit mode
        const isCostValueExists = tableData && tableData.some((item, index) => {
            if (isEditMode && index === editIndex) {
                return false; // Skip the current edited item
            }
            return item.CostHeaderName === newData.CostHeaderName;
        });

        if (isCostValueExists) {
            // Display toaster warning if CostHeaderName already exists
            Toaster.warning('Cost already exists in the table.');
            return; // Exit function early
        }

        // Update tableData state
        if (isEditMode) {
            const updatedTableData = [...tableData];
            updatedTableData[editIndex] = newData;
            updatedData.data = updatedTableData;
        } else {
            updatedData.data = [...tableData, newData];
        }

        setTableData(updatedData.data);

        // Reset input fields and states
        resetData(); // Assuming resetData correctly resets form inputs
        setIsEditMode(false);
        setEditIndex('');

        // Reset dropdowns to their initial state (placeholder)
        setValue('Cost', ''); // Reset to an empty string or null to show the placeholder
        setValue('Type', ''); // Reset to an empty string or null to show the placeholder
        setValue('Percentage', ''); // Reset Percentage field
        setValue('CostCurrency', ''); // Reset to an empty string or null to show the placeholder
        setValue('CostBaseCurrency', '');
        setValue('CostDescription', '');
        setState(prevState => ({ ...prevState, disableCostBaseCurrency: false, disableCostCurrency: false }));
    };
    const resetData = (type = '') => {
        const commonReset = () => {
            setDisableAllFields(true);
            setDisableTotalCost(true);
            setType('');
            setEditIndex('');
            setIsEditMode(false)
            setExactCostValues({
                ApplicabilityCostCurrency: '',
                ApplicabilityBaseCost: '',
                CostCurrency: '',
                CostBaseCurrency: ''
            });
            reset({
                Cost: '',
                Type: '',
                Percentage: '',
                CostCurrency: '',
                CostBaseCurrency: '',
                CostDescription: '',
                Remark: ''
            });
        };
        commonReset();
    };

    const handleType = (type) => {
        if (type && type !== '') {
            setType(type);
            setValue('CostCurrency', '')
            setValue('CostBaseCurrency', '')
            setValue('Percentage', '')
            setValue('Applicability', '')
            setValue('ApplicabilityCostCurrency', '')
            setValue('ApplicabilityBaseCost', '')
            if (type?.label === "Percentage") {
                setState(prevState => ({ ...prevState, disableApplicability: false }));
            } else {
                setState(prevState => ({ ...prevState, disableApplicability: true }));
            }
        } else {
            setType('');
        }
    }

    return (

        <div>
            <Drawer anchor={props.anchor} open={props.isOpen}
            >
                <div className={`ag-grid-react hidepage-size`}>
                    <Container className="add-bop-drawer">
                        <div className={'drawer-wrapper layout-min-width-1000px'}>

                            <Row className="drawer-heading">
                                <Col className="pl-0">
                                    <div className={'header-wrapper left'}>
                                        <h3>{'Other Cost:'}</h3>
                                    </div>
                                    <div
                                        onClick={cancel}
                                        className={'close-button right'}>
                                    </div>
                                </Col>
                            </Row>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='hidepage-size'>

                                    <Row>
                                        <Col md="3" className='px-2'>
                                            <SearchableSelectHookForm
                                                label={`Cost`}
                                                name={'Cost'}
                                                placeholder={'Select'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                // options={conditionDropdown}
                                                options={state.costDropdown}

                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.Cost}
                                                disabled={props.ViewMode || isEditMode}
                                            />
                                        </Col>
                                        <Col md="3" className='px-2'>
                                            <TextFieldHookForm
                                                label="Cost Description"
                                                name={"CostDescription"}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, hashValidation, maxLength80 },

                                                }}
                                                handleChange={() => { }}
                                                defaultValue={""}
                                                className=""
                                                customClassName={"withBorder"}
                                                errors={errors.CostDescription}
                                                disabled={props.ViewMode}
                                            />
                                        </Col>
                                        <Col md={3} className='px-2'>
                                            <SearchableSelectHookForm
                                                label={`Type`}
                                                name={'Type'}
                                                placeholder={'Select'}

                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                options={renderListing('Type')}
                                                handleChange={handleType}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.Type}
                                                disabled={props.ViewMode}
                                            />
                                        </Col>

                                        {
                                            type.label === 'Percentage' &&
                                            <>
                                                <Col md="3" className='px-2'>
                                                    <SearchableSelectHookForm
                                                        label={`Applicability`}
                                                        name={'Applicability'}
                                                        placeholder={'Select'}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        options={combinations}
                                                        handleChange={applicabilityChange}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.Applicability}
                                                        disabled={false}
                                                    />
                                                </Col>
                                                {!props.rawMaterial && <Col md={3} className={'px-2'}>
                                                    <TextFieldHookForm
                                                        label={`Applicability Cost (${Currency}${UOM ? `/${UOM}` : ''})`}
                                                        name={'ApplicabilityCostCurrency'}
                                                        id={'cost-by-percent'}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        rules={{
                                                            required: true,
                                                            validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                        }}
                                                        handleChange={() => { }}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.ApplicabilityCostCurrency}
                                                        disabled={props.ViewMode || disableTotalCost || disableCurrency}
                                                    />
                                                </Col>}
                                                <Col md={3} className={'px-2'}>

                                                    <TextFieldHookForm
                                                        label={`Applicability Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}
                                                        name={'ApplicabilityBaseCost'}
                                                        id={'cost-by-percent'}
                                                        Controller={Controller}

                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        rules={{
                                                            required: true,
                                                            validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                        }}
                                                        handleChange={() => { }}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.ApplicabilityBaseCost}
                                                        disabled={props.ViewMode || disableTotalCost || disableCurrency}
                                                    />
                                                </Col>
                                                <Col md={3} className='px-2'>
                                                    <TextFieldHookForm
                                                        label={`Percentage (%)`}
                                                        name={'Percentage'}
                                                        Controller={Controller}

                                                        control={control}
                                                        register={register}
                                                        mandatory={true}
                                                        rules={{
                                                            required: false,
                                                            validate: { number, checkWhiteSpaces, percentageLimitValidation },
                                                            max: {
                                                                value: 100,
                                                                message: 'Percentage cannot be greater than 100'
                                                            },
                                                        }}
                                                        handleChange={onPercentChange}
                                                        defaultValue={''}
                                                        className=""
                                                        customClassName={'withBorder'}
                                                        errors={errors.Percentage}
                                                        disabled={props.ViewMode}
                                                    />
                                                </Col ></>}
                                        {!props.rawMaterial && <Col md={3} className={'px-2'}>

                                            <TextFieldHookForm
                                                label={`Cost (${Currency}${UOM ? `/${UOM}` : ''})`}
                                                name={'CostCurrency'}
                                                id={'cost-by-percent'}
                                                Controller={Controller}

                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                }}
                                                handleChange={handleCostChangeCurrency}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.CostCurrency}
                                                disabled={type?.label === 'Percentage' ? true : false || state.disableCostCurrency || props.ViewMode}
                                            />
                                        </Col>}
                                        <Col md={3} className={'px-2'}>

                                            <TextFieldHookForm
                                                label={`Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}
                                                name={'CostBaseCurrency'}
                                                id={'cost-by-percent'}
                                                Controller={Controller}

                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { number, checkWhiteSpaces, decimalNumberLimit6 },
                                                }}
                                                handleChange={handleCostChangeBase}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.CostBaseCurrency}
                                                disabled={type?.label === 'Percentage' ? true : false || state.disableCostBaseCurrency || props.ViewMode}
                                            />
                                        </Col>
                                        <Col md="3" className='px-2'>
                                            <TextFieldHookForm
                                                label="Remark"
                                                name={"Remark"}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={true}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, hashValidation, maxLength80 }

                                                }}
                                                handleChange={() => { }}
                                                defaultValue={""}
                                                className=""
                                                customClassName={"withBorder"}
                                                errors={errors.Remark}
                                                disabled={props.ViewMode}
                                            />
                                        </Col>
                                        <Col md="3" className={toggleCondition()}>
                                            <button
                                                type="button"
                                                className={"user-btn  pull-left mt-1"}
                                                onClick={addData}
                                                disabled={props.ViewMode || props?.disabled}
                                            >
                                                {isEditMode ? "" : <div className={"plus"}></div>} {isEditMode ? "UPDATE" : 'ADD'}
                                            </button>
                                            <button
                                                type="button"
                                                className={"reset-btn pull-left mt-1 ml5"}
                                                onClick={() => resetData("reset")}
                                                disabled={props.ViewMode || props?.disabled}
                                            >
                                                {isEditMode ? "CANCEL" : 'RESET'}
                                            </button>
                                        </Col >
                                    </Row >
                                    <Col md={props.hideAction ? 12 : 12}>
                                        <Table className="table cr-brdr-main mb-0 forging-cal-table" size="sm">
                                            <tbody>
                                                <tr className='thead'>
                                                    <th>{`Cost`}</th>
                                                    <th>{`Cost Description`}</th>
                                                    <th>{`Type`}</th>
                                                    <th>{`Applicability`}</th>
                                                    {(!props.rawMaterial || isBOP) && <th>{`Applicability Cost (${Currency}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    {!isBOP && <th>{`Applicability Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    <th>{`Percentage (%)`}</th>
                                                    {(!props.rawMaterial || isBOP) && <th>{`Cost (${Currency}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    {!isBOP && <th>{`Cost (${CurrencyLabel}${UOM ? `/${UOM}` : ''})`}</th>}
                                                    <th>{`Remark`}</th>
                                                    {!props.hideAction && <th className='text-right'>{`Action`}</th>}
                                                </tr>

                                                {tableData && tableData.map((item, index) => (
                                                    <Fragment key={index}>
                                                        <tr>
                                                            <td>{item.CostHeaderName}</td>
                                                            <td>{item.Description}</td>
                                                            <td>{item.Type}</td>
                                                            <td>{item.Applicability}</td>
                                                            {(!props.rawMaterial || isBOP) && <td>{checkForDecimalAndNull(item.ApplicabilityCost, initialConfiguration?.NoOfDecimalForPrice)}</td>}
                                                            {!isBOP && <td>{checkForDecimalAndNull(item.ApplicabilityCostConversion, initialConfiguration?.NoOfDecimalForPrice)}</td>}
                                                            <td>{item.Value !== '-' ? checkForDecimalAndNull(item.Value, initialConfiguration?.NoOfDecimalForPrice) : '-'}</td>
                                                            {(!props.rawMaterial || isBOP) && <td>{item.NetCost !== '-' ? checkForDecimalAndNull(item.NetCost, initialConfiguration?.NoOfDecimalForPrice) : '-'}</td>}
                                                            {!isBOP && <td>{RawMaterialNonIndexed ? checkForDecimalAndNull(item?.NetCost, initialConfiguration?.NoOfDecimalForPrice) : checkForDecimalAndNull(item?.NetCostConversion, initialConfiguration?.NoOfDecimalForPrice)}</td>}
                                                            <td>{item.Remark}</td>
                                                            {!props.hideAction && (
                                                                <td>
                                                                    <div className='text-right'>
                                                                        <button title='Edit' className="Edit mr-1" type='button' onClick={() => editDeleteData(index, 'edit')} disabled={props.ViewMode} />
                                                                        <button title='Delete' className="Delete mr-1" type='button' onClick={() => editDeleteData(index, 'delete')} disabled={props.ViewMode} />
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    </Fragment>
                                                ))}

                                                {tableData && tableData.length === 0 && (
                                                    <tr>
                                                        <td colSpan="10">
                                                            <NoContentFound title={EMPTY_DATA} />
                                                        </td>
                                                    </tr>
                                                )}

                                                <tr className='table-footer'>
                                                    <td colSpan={props.rawMaterial ? 6 : 7} className="text-right font-weight-600 fw-bold">{'Total Cost:'}</td>
                                                    {!props.rawMaterial &&
                                                        <td>
                                                            <div className='d-flex justify-content-between'>
                                                                {checkForDecimalAndNull(totalCostCurrency, initialConfiguration?.NoOfDecimalForPrice)}
                                                            </div>
                                                        </td>
                                                    }
                                                    <td colSpan={3} className="text-left">
                                                        {checkForDecimalAndNull((isBOP || RawMaterialNonIndexed ? totalCostCurrency : totalCostBase), initialConfiguration?.NoOfDecimalForPrice)} ({CurrencyLabel})
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>

                                </div >
                                <Row className="sf-btn-footer no-gutters drawer-sticky-btn justify-content-between mx-0">
                                    <div className="col-sm-12 text-left bluefooter-butn d-flex justify-content-end">
                                        <button
                                            type={'button'}
                                            className="reset cancel-btn mr5"
                                            onClick={cancel || props?.disabled} >
                                            <div className={'cancel-icon'}></div> {'Cancel'}
                                        </button>
                                        <button
                                            type={'button'}
                                            className="submit-button save-btn"
                                            onClick={() => props.closeDrawer('Save', tableData, totalCostCurrency, totalCostBase, RowIndex)}
                                            disabled={props.ViewMode || props?.disabled}
                                        >
                                            <div className={"save-icon"}></div>
                                            {'Save'}
                                        </button>
                                    </div>
                                </Row>
                            </form>
                        </div >
                    </Container >
                </div >
            </Drawer >
        </div >
    )
}
export default React.memo(AddOtherCostDrawer)